import { useNavigate } from 'react-router'
import { Button } from '@/components/ui/shadcn/button'
import { useSidebarStore } from '@/stores/sidebarStore'
import { Send } from 'lucide-react'
import { MenuIcon } from './icons/icons-new'
import { CassiSquareIcon } from './icons/CassiSquareIcon'

type Props = {
  onPost?: () => void
}

export function Header({ onPost }: Props) {
  const navigate = useNavigate()
  const { isOpen, toggleSidebar } = useSidebarStore()

  return (
    <>
      {/* Phones get a bar in the page flow instead of the floating toggle: floating,
          it sat on top of every page's headline. Being in flow, it pushes the page
          down by itself. It stays under the sidebar (z-30), which covers the screen
          on phones and brings its own toggle. */}
      <div className="bg-background/95 border-border sticky top-0 z-20 flex h-12 w-full shrink-0 items-center gap-1 border-b px-2 backdrop-blur md:hidden">
        <Button size="icon" variant="ghost" onClick={toggleSidebar} aria-label="Open menu">
          <MenuIcon width={24} height={24} color="var(--foreground)" />
        </Button>
        <Button size="icon" variant="ghost" onClick={() => navigate('/')} aria-label="Home">
          <CassiSquareIcon width="24" height="24" />
        </Button>
      </div>

      <div
        className={`fixed left-3 top-2 z-50 hidden items-center gap-2 md:flex ${isOpen ? 'invisible opacity-0' : 'visible opacity-100'} transition-visibility transition-opacity delay-300 duration-300`}>
        <Button size="icon" variant="ghost" onClick={toggleSidebar}>
          <MenuIcon width={26} height={26} color="var(--foreground)" />
        </Button>
      </div>

      <div className="fixed right-3 top-2 z-50 flex items-center gap-2">
        {onPost && (
          <Button size="default" onClick={onPost}>
            <Send /> Post
          </Button>
        )}
      </div>
    </>
  )
}
